var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": "right",
                  "label-width": "120px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "指标编码", prop: "factorCode" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.factorCode,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "factorCode",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.factorCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "指标名称", prop: "factorName" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "100%" },
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.factorName,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.queryCondition,
                                    "factorName",
                                    $$v
                                  )
                                },
                                expression: "queryCondition.factorName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "制成", prop: "processId" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { filterable: "" },
                                model: {
                                  value: _vm.queryCondition.processId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.queryCondition,
                                      "processId",
                                      $$v
                                    )
                                  },
                                  expression: "queryCondition.processId",
                                },
                              },
                              _vm._l(_vm.processList, function (item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "状态", prop: "status" } },
                          [
                            _c("ic-select", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                table: "TT_PROC",
                                field: "STATUS",
                                clearable: "",
                              },
                              model: {
                                value: _vm.queryCondition.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "status", $$v)
                                },
                                expression: "queryCondition.status",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onSearch },
                      },
                      [_vm._v("查询")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.onReset },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.PROC_FACTOR_MANAGE_MAINTAIN,
                    expression: "PROC_FACTOR_MANAGE_MAINTAIN",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.handleAdd },
              },
              [_vm._v("新增")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.PROC_FACTOR_MANAGE_MAINTAIN,
                    expression: "PROC_FACTOR_MANAGE_MAINTAIN",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "danger" },
                on: { click: _vm.handleBatchDelete },
              },
              [_vm._v("批量删除")]
            ),
          ],
          1
        ),
        _c(
          "el-row",
          [
            _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.tableData,
                  "max-height": "425",
                  border: "",
                  stripe: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55" },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "sortIndex",
                    label: "序号",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "sortIndex"),
                    width: "60",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "factorCode",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "factorCode"),
                    label: "指标编码",
                    "min-width": "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "factorName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "factorName"),
                    label: "指标名称",
                    "min-width": "120",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "factorDesc",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "factorDesc"),
                    label: "指标描述",
                    "min-width": "200",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "processName",
                    sortable: "",
                    "sort-method": (a, b) =>
                      _vm.sortMethods(a, b, "processName"),
                    label: "所属制成",
                    "min-width": "150",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "inputMode",
                    sortable: "",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "inputMode"),
                    label: "输入模式",
                    "min-width": "150",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type: _vm.getIndicatorInputModeTag(
                                  scope.row.inputMode
                                ),
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(scope.row.inputModeText) + " "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "status",
                    sortable: "",
                    "sort-method": (a, b) => _vm.sortMethods(a, b, "status"),
                    label: "状态",
                    "min-width": "80",
                    "show-overflow-tooltip": "",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-tag",
                            {
                              attrs: {
                                type:
                                  scope.row.status === "ACTIVE"
                                    ? "success"
                                    : "danger",
                              },
                            },
                            [_vm._v(" " + _vm._s(scope.row.statusText) + " ")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createBy",
                    label: "创建人",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "createDate",
                    label: "创建时间",
                    "min-width": "180",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateBy",
                    label: "更新人",
                    "min-width": "100",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "updateDate",
                    label: "更新时间",
                    "min-width": "180",
                    "show-overflow-tooltip": "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "操作",
                    "min-width": "250",
                    fixed: "right",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.PROC_FACTOR_MANAGE_MAINTAIN,
                                  expression: "PROC_FACTOR_MANAGE_MAINTAIN",
                                },
                              ],
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEdit(scope.row)
                                },
                              },
                            },
                            [_vm._v("编辑")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.PROC_FACTOR_MANAGE_MAINTAIN,
                                  expression: "PROC_FACTOR_MANAGE_MAINTAIN",
                                },
                              ],
                              attrs: { type: "primary", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleManageParams(scope.row)
                                },
                              },
                            },
                            [_vm._v("参数管理")]
                          ),
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "acl",
                                  rawName: "v-acl",
                                  value: _vm.PROC_FACTOR_MANAGE_MAINTAIN,
                                  expression: "PROC_FACTOR_MANAGE_MAINTAIN",
                                },
                              ],
                              attrs: { type: "danger", size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(scope.row)
                                },
                              },
                            },
                            [_vm._v("删除")]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.queryCondition.pageNum,
                    "page-sizes": _vm.pageSizeList,
                    "page-size": _vm.queryCondition.pageSize,
                    layout: _vm.pageLayout,
                    total: _vm.totalCount,
                    "page-count": _vm.pages,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "process_dialog",
            attrs: {
              title: _vm.dialogTitle,
              visible: _vm.dialogVisible,
              width: "40%",
              "close-on-click-modal": false,
              top: "10px",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogVisible = $event
              },
              close: _vm.onClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "formData",
                attrs: {
                  model: _vm.formData,
                  rules: _vm.formRules,
                  "label-width": "90px",
                  width: "40%",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "指标编码", prop: "factorCode" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.formData.factorCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "factorCode", $$v)
                        },
                        expression: "formData.factorCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "指标名称", prop: "factorName" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入指标名称",
                        maxlength: "50",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.formData.factorName,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "factorName", $$v)
                        },
                        expression: "formData.factorName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "指标描述", prop: "factorDesc" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "请输入指标描述",
                        maxlength: "500",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.formData.factorDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "factorDesc", $$v)
                        },
                        expression: "formData.factorDesc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "所属制成", prop: "processId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          filterable: "",
                          disabled: _vm.indicatorType !== "add",
                        },
                        model: {
                          value: _vm.formData.processId,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "processId", $$v)
                          },
                          expression: "formData.processId",
                        },
                      },
                      _vm._l(_vm.processList1, function (item, index) {
                        return _c("el-option", {
                          key: index,
                          attrs: {
                            disabled: item.disabled,
                            label: item.label,
                            value: item.value,
                          },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "输入模式", prop: "inputMode" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_PROC",
                        field: "INPUT_MODE",
                        clearable: "",
                        disabled: _vm.indicatorType !== "add",
                      },
                      model: {
                        value: _vm.formData.inputMode,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "inputMode", $$v)
                        },
                        expression: "formData.inputMode",
                      },
                    }),
                  ],
                  1
                ),
                _vm.formData.inputMode == "LIST"
                  ? _c(
                      "el-form-item",
                      {
                        attrs: { label: "指标处理器", prop: "factorProcessor" },
                      },
                      [
                        _c("ic-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            table: "TT_PROC",
                            field: "FACTOR_PROCESSOR",
                            clearable: "",
                            disabled: _vm.indicatorType !== "add",
                          },
                          model: {
                            value: _vm.formData.factorProcessor,
                            callback: function ($$v) {
                              _vm.$set(_vm.formData, "factorProcessor", $$v)
                            },
                            expression: "formData.factorProcessor",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "序号", prop: "sortIndex" } },
                  [
                    _c("el-input", {
                      attrs: {
                        oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                        disabled: _vm.indicatorType !== "add",
                        placeholder: "请输入序号",
                      },
                      model: {
                        value: _vm.formData.sortIndex,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "sortIndex", $$v)
                        },
                        expression: "formData.sortIndex",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_PROC",
                        field: "STATUS",
                        disabled: _vm.indicatorType == "add",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "status", $$v)
                        },
                        expression: "formData.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveDisabled,
                      loading: _vm.isSaveLoading,
                    },
                    on: { click: _vm.onSave },
                  },
                  [_vm._v("确定")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onClose },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "process_dialog",
            attrs: {
              title: _vm.paramDialogTitle,
              visible: _vm.paramDialogVisible,
              width: "75%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.paramDialogVisible = $event
              },
              close: _vm.onCloseParam,
            },
          },
          [
            _c("div", { staticClass: "param-management" }, [
              _c("div", { staticClass: "param-header" }, [
                _c("div", { staticClass: "header-left" }, [
                  _c("span", { staticClass: "indicator-desc" }, [
                    _vm._v(_vm._s(_vm.currentIndicator.factorDesc)),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "header-right" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "primary",
                          icon: "el-icon-plus",
                          size: "mini",
                        },
                        on: { click: _vm.handleAddParam },
                      },
                      [_vm._v("新增参数")]
                    ),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "indicator-input-mode-config" }, [
                _c("div", { staticClass: "config-section" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c("i", { staticClass: "el-icon-setting" }),
                      _c("span", [_vm._v("指标输入模式配置")]),
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type: _vm.getIndicatorInputModeTag(
                              _vm.currentIndicator.inputMode
                            ),
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.currentIndicator.inputModeText) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "form-mode-info" }, [
                    _c(
                      "div",
                      {
                        class:
                          _vm.currentIndicator.inputMode === "TABLE"
                            ? "matrix-confgi-section isPadding"
                            : "matrix-confgi-section",
                      },
                      [
                        _c("div", { staticClass: "quick-config" }, [
                          _vm.currentIndicator.inputMode === "TABLE"
                            ? _c("p", { staticClass: "config-tip" }, [
                                _vm._v("配置多值维度列："),
                              ])
                            : _vm._e(),
                          _c(
                            "div",
                            { staticClass: "quick-buttons" },
                            [
                              _vm.currentIndicator.inputMode === "TABLE"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: _vm.handleOpenMultiValuesDialog,
                                      },
                                    },
                                    [_vm._v("配置多值维度")]
                                  )
                                : _vm._e(),
                              _c(
                                "el-button",
                                {
                                  attrs: {
                                    type: "success",
                                    size: "mini",
                                    disabled:
                                      _vm.multiForm.valueColumns.length === 0,
                                    icon: "el-icon-view",
                                  },
                                  on: { click: _vm.handlePreviewMatrixMode },
                                },
                                [_vm._v("预览数据录入界面")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "param-table" },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.paramTableData,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "sortIndex",
                            label: "序号",
                            width: "60",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "paramCode",
                            label: "参数编码",
                            width: "120",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "paramName",
                            label: "参数名称",
                            width: "150",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "paramDesc",
                            label: "参数描述",
                            width: "200",
                            "show-overflow-tooltip": "",
                          },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dataTypeText",
                            label: "数据类型",
                            width: "100",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.getDataTypeTag(
                                          scope.row.dataType
                                        ),
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(scope.row.dataTypeText) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "required",
                            label: "是否必填",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: scope.row.required
                                          ? "success"
                                          : "info",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.required ? "是" : "否"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { prop: "uom", label: "单位", width: "80" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "statusText",
                            label: "状态",
                            width: "80",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.status === "ACTIVE"
                                            ? "success"
                                            : "danger",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            scope.row.status === "ACTIVE"
                                              ? "启用"
                                              : "禁用"
                                          ) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            label: "操作",
                            "min-width": "200",
                            align: "center",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEditParam(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("编辑")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDeleteParam(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.paramFormVisible,
              title: _vm.paramFormTitle,
              width: "35%",
              "append-to-body": "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.paramFormVisible = $event
              },
              close: _vm.handleParamFormClose,
            },
          },
          [
            _c(
              "el-form",
              {
                ref: "paramFormRef",
                attrs: {
                  model: _vm.paramFormData,
                  rules: _vm.paramFormRules,
                  "label-width": "100px",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "参数编码", prop: "paramCode" } },
                  [
                    _c("el-input", {
                      attrs: { disabled: "" },
                      model: {
                        value: _vm.paramFormData.paramCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "paramCode", $$v)
                        },
                        expression: "paramFormData.paramCode",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "参数名称", prop: "paramName" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入参数名称",
                        maxlength: "50",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.paramFormData.paramName,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "paramName", $$v)
                        },
                        expression: "paramFormData.paramName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "参数描述", prop: "paramDesc" } },
                  [
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: 3,
                        placeholder: "请输入参数描述",
                        maxlength: "200",
                        "show-word-limit": "",
                      },
                      model: {
                        value: _vm.paramFormData.paramDesc,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "paramDesc", $$v)
                        },
                        expression: "paramFormData.paramDesc",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "数据类型", prop: "dataType" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_PROC",
                        field: "DATA_TYPE",
                        clearable: "",
                      },
                      model: {
                        value: _vm.paramFormData.dataType,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "dataType", $$v)
                        },
                        expression: "paramFormData.dataType",
                      },
                    }),
                  ],
                  1
                ),
                _vm.paramFormData.dataType == "SELECTOR"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "选择器类型", prop: "selectorType" } },
                      [
                        _c("ic-select", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            table: "TT_PROC",
                            field: "SELECTOR_TYPE",
                            clearable: "",
                          },
                          model: {
                            value: _vm.paramFormData.selectorType,
                            callback: function ($$v) {
                              _vm.$set(_vm.paramFormData, "selectorType", $$v)
                            },
                            expression: "paramFormData.selectorType",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.paramFormData.dataType == "DICT"
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "字典", prop: "selectorType" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入字典" },
                          model: {
                            value: _vm.paramFormData.selectorType,
                            callback: function ($$v) {
                              _vm.$set(_vm.paramFormData, "selectorType", $$v)
                            },
                            expression: "paramFormData.selectorType",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-form-item",
                  { attrs: { label: "单位", prop: "uom" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入单位" },
                      model: {
                        value: _vm.paramFormData.uom,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "uom", $$v)
                        },
                        expression: "paramFormData.uom",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "是否必填", prop: "required" } },
                  [
                    _c("el-switch", {
                      attrs: { "active-text": "是", "inactive-text": "否" },
                      model: {
                        value: _vm.paramFormData.required,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "required", $$v)
                        },
                        expression: "paramFormData.required",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "序号", prop: "sortIndex" } },
                  [
                    _c("el-input", {
                      attrs: {
                        oninput: "value=value.replace(/^(0+)|[^\\d]+/g,'')",
                        placeholder: "请输入序号",
                      },
                      model: {
                        value: _vm.paramFormData.sortIndex,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "sortIndex", $$v)
                        },
                        expression: "paramFormData.sortIndex",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "状态", prop: "status" } },
                  [
                    _c("ic-select", {
                      staticStyle: { width: "100%" },
                      attrs: {
                        table: "TT_PROC",
                        field: "STATUS",
                        disabled: _vm.paramType == "add",
                        clearable: "",
                      },
                      model: {
                        value: _vm.paramFormData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.paramFormData, "status", $$v)
                        },
                        expression: "paramFormData.status",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "primary",
                      loading: _vm.paramSubmitLoading,
                      disabled: _vm.paramSubmitDisabled,
                    },
                    on: { click: _vm.handleParamSubmit },
                  },
                  [_vm._v("确定")]
                ),
                _c("el-button", { on: { click: _vm.handleParamFormClose } }, [
                  _vm._v("取消"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "process_dialog",
            attrs: {
              title: "多值维度配置",
              visible: _vm.multiValuesDialogVisible,
              width: "60%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.multiValuesDialogVisible = $event
              },
              close: _vm.onCloseMultiDialog,
            },
          },
          [
            _c(
              "div",
              { staticClass: "multi-values-container" },
              [
                _c("div", { staticClass: "columns-header" }, [
                  _c("h5", [_vm._v("输入列配置")]),
                  _c(
                    "div",
                    { staticClass: "header-actions" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.handleAddValueColumn },
                        },
                        [_vm._v("添加列")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "success",
                            size: "small",
                            icon: "el-icon-plus",
                          },
                          on: { click: _vm.handleQuickAddRangeColumns },
                        },
                        [_vm._v("快速添加范围列")]
                      ),
                      _vm.multiForm.valueColumns.length > 0
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                type: "warning",
                                size: "small",
                                icon: "el-icon-delete",
                              },
                              on: { click: _vm.handleClearAllColumns },
                            },
                            [_vm._v("清空所有列")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form",
                  { ref: "multiForm", attrs: { model: _vm.multiForm } },
                  [
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.multiForm.valueColumns,
                          "max-height": "425",
                          border: "",
                          stripe: "",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { type: "index", label: "序号", width: "60" },
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "columnName",
                            label: "列名称",
                            "min-width": "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "valueColumns." +
                                          scope.$index +
                                          ".columnName",
                                        rules: _vm.columnNameRules(
                                          scope.$index,
                                          scope.row
                                        ),
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "如:每100克" },
                                        model: {
                                          value: scope.row.columnName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "columnName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.columnName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: {
                            prop: "columnDesc",
                            label: "描述",
                            "min-width": "200",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        prop:
                                          "valueColumns." +
                                          scope.$index +
                                          ".columnDesc",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { placeholder: "如:每100克" },
                                        model: {
                                          value: scope.row.columnName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "columnName",
                                              $$v
                                            )
                                          },
                                          expression: "scope.row.columnName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作", "min-width": "100" },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "danger",
                                        size: "small",
                                        icon: "el-icon-delete",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleRemoveValueColumn(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: {
                      size: "mini",
                      type: "primary",
                      disabled: _vm.isSaveMultiDisabled,
                      loading: _vm.isSaveMultiLoading,
                    },
                    on: { click: _vm.handleSaveMultiValues },
                  },
                  [_vm._v("保存配置")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onCloseMultiDialog },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "process_dialog",
            attrs: {
              visible: _vm.rangeColumnsDialogVisible,
              title: "快速添加范围列",
              width: "40%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.rangeColumnsDialogVisible = $event
              },
              close: _vm.onCloseRangeConfigDialog,
            },
          },
          [
            _c(
              "div",
              { staticClass: "range-config-container" },
              [
                _c("div", { staticClass: "config-tip" }, [
                  _c("span", [
                    _vm._v(
                      "快速生成连续数字列,如:1、2、3、4...或者生产日期、小批次等"
                    ),
                  ]),
                ]),
                _c("div", { staticClass: "quick-presets" }, [
                  _c("h5", [_vm._v("常用预设：")]),
                  _c(
                    "div",
                    { staticClass: "preset-buttons" },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("1-10")
                            },
                          },
                        },
                        [_vm._v("1-10")]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("1-20")
                            },
                          },
                        },
                        [_vm._v("1-20")]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("1-50")
                            },
                          },
                        },
                        [_vm._v("1-50")]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("1-100")
                            },
                          },
                        },
                        [_vm._v("1-100")]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("days")
                            },
                          },
                        },
                        [_vm._v("生产日期(1-31天)")]
                      ),
                      _c(
                        "el-tag",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function ($event) {
                              return _vm.applyPreset("batches")
                            },
                          },
                        },
                        [_vm._v("小批次(1-20批)")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c(
                  "el-form",
                  { attrs: { model: _vm.rangeConfig, "label-width": "100px" } },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "列名前缀" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "如：第、批次、日期" },
                          on: { input: _vm.setPreviewLists },
                          model: {
                            value: _vm.rangeConfig.prefix,
                            callback: function ($$v) {
                              _vm.$set(_vm.rangeConfig, "prefix", $$v)
                            },
                            expression: "rangeConfig.prefix",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "起始数字" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 1, max: 1000 },
                          on: { change: _vm.numberChange },
                          model: {
                            value: _vm.rangeConfig.startNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.rangeConfig, "startNumber", $$v)
                            },
                            expression: "rangeConfig.startNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "结束数字" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "200px" },
                          attrs: { min: 1, max: 1000 },
                          on: { change: _vm.numberChange },
                          model: {
                            value: _vm.rangeConfig.endNumber,
                            callback: function ($$v) {
                              _vm.$set(_vm.rangeConfig, "endNumber", $$v)
                            },
                            expression: "rangeConfig.endNumber",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "列名后缀" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "如：天、次、批" },
                          on: { input: _vm.setPreviewLists },
                          model: {
                            value: _vm.rangeConfig.suffix,
                            callback: function ($$v) {
                              _vm.$set(_vm.rangeConfig, "suffix", $$v)
                            },
                            expression: "rangeConfig.suffix",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("div", { staticClass: "preview-section" }, [
                  _c("h5", [_vm._v("预览效果(显示前10列):")]),
                  _c(
                    "div",
                    { staticClass: "preview-tags" },
                    [
                      _vm._l(
                        _vm.rangePreview.slice(0, 10),
                        function (preview, index) {
                          return _c(
                            "el-tag",
                            {
                              key: index,
                              staticClass: "preview-tag",
                              attrs: { type: "primary", size: "small" },
                            },
                            [_vm._v(" " + _vm._s(preview) + " ")]
                          )
                        }
                      ),
                      _vm.rangePreview.length > 10
                        ? _c(
                            "el-tag",
                            { attrs: { type: "info", size: "small" } },
                            [
                              _vm._v(
                                " ...还有" +
                                  _vm._s(_vm.rangePreview.length - 10) +
                                  "列 "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex", justify: "center" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.handleConfirmAddRangeColumns },
                  },
                  [_vm._v("添加 " + _vm._s(_vm.rangePreview.length) + " 列")]
                ),
                _c(
                  "el-button",
                  { on: { click: _vm.onCloseRangeConfigDialog } },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "process_dialog",
            attrs: {
              title: _vm.title,
              visible: _vm.previewDialogVisible,
              width: "90%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.previewDialogVisible = $event
              },
            },
          },
          [
            _c("previewDialog", {
              attrs: {
                previewMultiLists: _vm.previewMultiLists,
                previewColumns: _vm.previewColumns,
              },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }